import AddSvg from 'asset/baga/cart-add.svg'
import AddedSvg from 'asset/baga/cart-added.svg'
import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { Loader } from 'component/Loader'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { client } from 'config/environment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { useTryOn } from 'hook/useTryOn'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { Item } from 'type/Item'
import css from './TryButtonBaga.module.scss'

type Props = {
  item: Item
}

export const TryButtonBaga = observer(({ item }: Props) => {
  const demo = useDemo()
  const { item_id } = item
  const { loading, onTry } = useTryOn({ itemId: item_id })
  const checked = client && comboCartStore.isItemInCart(item.item_id)
  const tryon = demo.canTry(item)
  const combo = demo.canCombine(item)

  const onCombo = useLatestCallback(() => {
    comboCartStore.toggleItem(item)
  })

  return <Space className={clsx(tryon && combo && css.both)} gap={2}>
    {tryon && <Button className={css.try} xl text compact action={onTry} disabled={loading}>
      {loading && <Space className={css.load} center>
        <Loader small />
      </Space>}
      <Typo className={clsx(loading && css.hide)}>
        {i18n('demo.TryOn')}
      </Typo>
    </Button>}
    {combo && <Button className={css.combo} xl text compact action={onCombo}>
      {checked ? <AddedSvg /> : <AddSvg />}
    </Button>}
  </Space>
})
